import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { SEO } from "@/components/common/SEO";
import { useAuth } from "@/context/AuthContext";
import { brand } from "@/config/brand";

const SIDE_IMAGE = "https://images.unsplash.com/photo-1585960622850-ed33c41d6418?auto=format&fit=crop&w=1000&q=80";

export default function RegisterPage() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (password.length < 6) {
      setError("Password must be at least 6 characters");
      return;
    }
    setBusy(true);
    const res = await register(name, email, password);
    setBusy(false);
    if (res.ok) navigate("/account");
    else setError(res.error);
  };

  const inputCls = "w-full border border-border bg-transparent px-4 py-3 text-sm focus:border-gold focus:outline-none";

  return (
    <div className="grid min-h-[80vh] grid-cols-1 lg:grid-cols-2">
      <SEO title="Create Account" />
      <div className="flex items-center justify-center px-6 py-16 lg:order-1">
        <div className="w-full max-w-sm">
          <span className="text-luxe text-xs font-medium text-gold">Join ÉLORA</span>
          <h1 className="mt-3 font-serif text-4xl font-light text-ink">Create Account</h1>
          <p className="mt-2 text-sm text-muted-foreground">Save favourites, track orders and enjoy member perks.</p>

          <form onSubmit={submit} className="mt-8 space-y-5" data-testid="register-form">
            <div>
              <label className="text-luxe text-[10px] text-ink">Full Name</label>
              <input required value={name} onChange={(e) => setName(e.target.value)} className={`mt-2 ${inputCls}`} data-testid="register-name-input" />
            </div>
            <div>
              <label className="text-luxe text-[10px] text-ink">Email</label>
              <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className={`mt-2 ${inputCls}`} data-testid="register-email-input" />
            </div>
            <div>
              <label className="text-luxe text-[10px] text-ink">Password</label>
              <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className={`mt-2 ${inputCls}`} data-testid="register-password-input" />
            </div>
            {error && <p className="text-xs text-destructive" data-testid="register-error">{error}</p>}
            <button type="submit" disabled={busy} data-testid="register-submit-button" className="w-full bg-ink py-4 text-[11px] font-medium uppercase tracking-[0.2em] text-ivory transition-colors hover:bg-gold disabled:opacity-60">
              {busy ? "Creating…" : "Create Account"}
            </button>
          </form>

          <p className="mt-6 text-center text-sm text-muted-foreground">
            Already have an account?{" "}
            <Link to="/login" className="text-ink underline-offset-4 hover:text-gold hover:underline" data-testid="go-to-login">
              Sign in
            </Link>
          </p>
        </div>
      </div>

      <div className="relative hidden overflow-hidden lg:block">
        <img src={SIDE_IMAGE} alt="ÉLORA jewellery" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-ink/30" />
        <div className="absolute bottom-10 left-10 text-ivory">
          <p className="font-serif text-3xl font-light tracking-[0.18em]">{brand.name}</p>
          <p className="mt-1 text-sm text-ivory/80">{brand.tagline}</p>
        </div>
      </div>
    </div>
  );
}
